import React from 'react';
import { ReactComponent as StripeLogo } from '../svg/filled/stripe.svg';
import { ReactComponent as PayPalLogo } from '../svg/filled/paypal.svg';
import { ReactComponent as Payments } from '../svg/filled/payments.svg';
import { connect } from 'react-redux';
import { checkout } from '../redux/actions/checkout';
import { checkoutLoading, sessionKey } from '../redux/selectors/pagesSelectors';
import { cartMainProduct, cartRenewSelector } from '../redux/selectors/cartSelector';
import { PAYMENT_PAYPAL_ENABLED } from '../constants/constants';
import { setProceedToCheckoutAfterAuth } from '../redux/actions/pagesActions';

function Cards({
    checkout,
    checkoutLoading,
    cartRenew,
    sessionKey,
    setAccountFormIsVisible,
    setProceedToCheckoutAfterAuth,
}) {
    const handleStripe = () => {
        if (sessionKey) {
            checkout('stripe');
        } else {
            setAccountFormIsVisible(true);
            setProceedToCheckoutAfterAuth('stripe');
        }
    };

    const handlePayPal = () => {
        if (sessionKey) {
            checkout('paypal');
        } else {
            setAccountFormIsVisible(true);
            setProceedToCheckoutAfterAuth('paypal');
        }
    };

    const checkoutTitleStripe = cartRenew
        ? 'Subscribe to the service using a credit/debit card'
        : 'Make a one time credit/debit card payment';

    const checkoutTitlePayPal = cartRenew
        ? 'Subscribe to the service using PayPal'
        : 'Make a one time PayPal payment';

    return (
        <>
            <ul className={`card__list card__list${PAYMENT_PAYPAL_ENABLED ? '' : '--single'}`}>
                {!!PAYMENT_PAYPAL_ENABLED && (
                    <li className={'card__container'}>
                        <h3 className={'card__title'}>{checkoutTitlePayPal}</h3>

                        <PayPalLogo className={'card__logo'} />

                        <span className={'card__description'}>
                            It may take up to 5 minutes for the payment process
                        </span>

                        <button
                            disabled={checkoutLoading}
                            onClick={() => handlePayPal()}
                            type={'button'}
                            className={'button card__button button--proceed'}
                        >
                            <span className={'text-2 bold'}>Pay Now</span>
                        </button>
                    </li>
                )}
                <li className={'card__container'}>
                    <h3 className={'card__title'}>{checkoutTitleStripe}</h3>

                    <StripeLogo className={'card__logo'} />

                    <span className={'card__description'}>
                        It may take up to 5 minutes for the payment process
                    </span>

                    <button
                        disabled={checkoutLoading}
                        onClick={() => handleStripe()}
                        type={'button'}
                        className={'button card__button button--proceed'}
                    >
                        <span className={'text-2 bold'}>Pay Now</span>
                    </button>

                    <Payments className={'card__img'} />
                </li>
            </ul>
            <div className={'notification__message mb-60 mt-0'}>
                If you are not 100% satisfied with your purchase, within 60 days from the purchase
                date, we will fully refund the cost of your order.
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    mainProduct: cartMainProduct(state),
    checkoutLoading: checkoutLoading(state),
    cartRenew: cartRenewSelector(state),
    sessionKey: sessionKey(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkout: (provider) => dispatch(checkout(provider)),
    setProceedToCheckoutAfterAuth: (provider) => dispatch(setProceedToCheckoutAfterAuth(provider)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cards);

